import React from 'react';
import { CaptureOverlay } from '../shared';
import type { ScreenMode } from './useScreenRecorder';

interface ScreenRecordingProps {
  taskName: string;
  screenRef: React.RefObject<HTMLVideoElement | null>;
  camRef: React.RefObject<HTMLVideoElement | null>;
  mode: ScreenMode;
  duration: number;
  isLandscape: boolean;
  onStop: () => void;
  onClose: () => void;
}

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export const ScreenRecording: React.FC<ScreenRecordingProps> = ({
  taskName,
  screenRef,
  camRef,
  mode,
  duration,
  isLandscape,
  onStop,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className={isLandscape ? 'sc-landscape' : undefined}>
        <div className="sc-screen-body">
          <div className="sc-screen-gradient-dim" />
          <video ref={screenRef} autoPlay playsInline muted />

          {/* Rec badge */}
          <div className="sc-rec-badge">
            <div className="sc-rec-dot" />
            <div className="sc-rec-time">{formatTime(duration)}</div>
          </div>

          {/* Facecam PiP */}
          {mode === 'screen-cam' && (
            <div className="sc-facecam-bubble-rec">
              <video ref={camRef} autoPlay playsInline muted />
            </div>
          )}
        </div>

        <div className="sc-ctrl-bar">
          <div className="sc-status-dim">Recording…</div>
          <div className="sc-big-rec-btn" onClick={onStop}>
            <div className="sc-stop-square" />
          </div>
          <div className="sc-ctrl-spacer" />
        </div>
      </div>
    </CaptureOverlay>
  );
};
